import React from 'react';
import { Banner } from '../components/Banner';
import { getAnchorProps, getOnClick, getTermsAndConditions } from './utils';
import { logEvent } from '../error';
import { ImageSizeType } from '../consts';
export const mapContentstackData = ({ data, imageSize = ImageSizeType.SMALL, setLoaded, navigate, }) => {
    const { banners } = data;
    if (!banners || !Array.isArray(banners) || !banners.length) {
        logEvent({ objectName: 'jsonDataMapper', actionName: 'emptyOrInvalid' });
        return null;
    }
    return banners.map((banner, index) => {
        const { id, image, label, title } = banner;
        // Analytics prefers to count banners from 1 to n, so let's normalise this across whole component
        const incrementedIndex = index + 1;
        const bannerId = `banner-${incrementedIndex}-${id}`;
        const onClick = getOnClick({ index: incrementedIndex, banner, navigate });
        const { href, target, altText } = getAnchorProps(banner);
        return {
            Banner: (React.createElement(Banner, { href: href, image: image, imageSize: imageSize, index: incrementedIndex, target: target, title: altText ? altText : title, onClick: onClick, setLoaded: setLoaded })),
            id: bannerId,
            label,
            termsAndConditions: getTermsAndConditions(banner),
        };
    });
};
